module.exports = __webpack_public_path__ + "static/media/get-access.b75c347d.png";